import { TIconConfig } from '../../types/icon/icon-config.type';

export const ICON_PATH = '/images/icons';
export const IMAGES_PATH = '/images';
export const ICON_NAME_PREFIX = 'dss';
export const DEFAULT_ICON_VIEW_BOX = '0 0 24 24';

export const PORTAL_ICONS: TIconConfig[] = [
  { name: 'folder' },
  { name: 'folder-bold' },
  { name: 'document-add' },
  { name: 'document-add-bold', viewBox: '0 0 18 18' },
  { name: 'file-check' },
  { name: 'file-check-bold' },
  { name: 'file-remove' },
  { name: 'file-remove-bold' },
  { name: 'info-circle-outline' },
  { name: 'check-circle-outline' },
  { name: 'close-circle-outline' },
  { name: 'alt-arrow-down-outline' },
  { name: 'options', viewBox: '0 0 20 20' },
  { name: 'signing', viewBox: '0 0 16 16' },
  { name: 'plus-icon', viewBox: '0 0 28 28' },
  { name: 'minimalistic-magnifier-outline' },
  { name: 'user-plus-rounded-bold' },
  { name: 'user-plus-rounded-outline' },
  { name: 'trash-bin-minimalistic' },
  { name: 'trash-bin-minimalistic-outline' },
  { name: 'close', viewBox: '0 0 10 10' },
  { name: 'user-rounded' },
  { name: 'user-rounded-bold' },
  { name: 'users-group-two-rounded-bold' },
  { name: 'users-group-two-rounded-outline' },
  { name: 'banknote-2-outline' },
  { name: 'banknote-2-bold' },
  { name: 'pallete-2-outline' },
  { name: 'pallete-2-bold' },
  { name: 'cloud-upload-outline' },
  { name: 'file-outline' },
  { name: 'file-bold' },
  { name: 'danger-triangle-bold' },
  { name: 'danger-triangle-outline' },
  { name: 'user-circle-outline' },
  { name: 'buildings-outline' },
  { name: 'documents-outline' },
  { name: 'documents-bold' },
  { name: 'settings-outline' },
  { name: 'settings-bold' },
  { name: 'logout-2-outline' },
  { name: 'arrow-bar-right', viewBox: '0 0 16 16' },
  { name: 'bar-menu', viewBox: '0 0 24 16' },
  { name: 'close-menu', viewBox: '0 0 20 20' },
  { name: 'horizontal-transfer-outline' },
  { name: 'bell-outline' },
  { name: 'download-minimal-outline' },
  { name: 'download-minimalistic-outline' },
  { name: 'danger-triangle-outline' },
  { name: 'alt-arrow-right-outline' },
  { name: 'arrow-left-outline' },
  { name: 'info-circle-bold' },
  { name: 'close-circle-bold' },
  { name: 'check-circle-bold' },
  { name: 'bill-outline' },
  { name: 'key-minimalistic-square-3-outline' },
  { name: 'key-minimalistic-square-3-bold' },
  { name: 'key-outline' },
  { name: 'copy-outline' },
  { name: 'restart-square-outline' },
  { name: 'pen-2-outline' },
  { name: 'trash-bin-trash-outline' },
  { name: 'info-with-stroke-outline' },
  { name: 'menu-dots-outline' },
  { name: 'check-outline' },
];

export const SIGNATURE_ICONS: TIconConfig[] = [
  { name: 'alt-arrow-right-outline' },
  { name: 'danger-triangle-outline' },
  { name: 'check-circle-bold' },
  { name: 'close-circle-outline' },
  { name: 'close-circle-bold' },
  { name: 'info-circle-bold' },
  { name: 'clock-circle-bold' },
  { name: 'info-circle-fill' },
  { name: 'check' },
  { name: 'arrow-left' },
  { name: 'arrow-right' },
  { name: 'shield-check' },
  { name: 'document-text' },
  { name: 'refresh' },
  { name: 'danger-triangle-bold' },
];

export const FORMS_ICONS: TIconConfig[] = [
  { name: 'close-circle-bold' },
  { name: 'close', viewBox: '0 0 10 10' },
  { name: 'minimalistic-magnifier-outline' },
];

export const ALL_ICONS: TIconConfig[] = [...PORTAL_ICONS, ...SIGNATURE_ICONS, ...FORMS_ICONS];
